module.exports = __webpack_public_path__ + "img/ration-center.62b0b389.svg";